exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".external-image-container{display:flex;justify-content:center;align-items:center;width:100%;margin-top:0.5rem;margin-bottom:0.5rem}\n", ""]);

// exports
